module.exports = __webpack_public_path__ + "img/KF.3f0df6ea.png";